import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCuLy2gfM5_YBFqLbmGU07LDlFR3roPQzw",
    authDomain: "dangoni-a-dragoni.firebaseapp.com",
    projectId: "dangoni-a-dragoni",
    storageBucket: "dangoni-a-dragoni.appspot.com",
    messagingSenderId: "1074031120525",
    appId: "1:1074031120525:web:b529bc57be3024cd6dd2c4",
    measurementId: "G-2G1GESFCGT"
};
  
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
